import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { ExperienceLink } from './experienceLink.component';
import { selectCurrentKioskSlug, selectIsKioskMode } from '../../../modules/kiosk';

const mapStateToProps = createStructuredSelector({
  isKioskMode: selectIsKioskMode,
  kioskSlug: selectCurrentKioskSlug,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ExperienceLink);
